import { LucideIcon } from 'lucide-react'
import * as React from 'react'

import { Button, ButtonProps } from '../../ui/button'

export interface IconButtonProps extends ButtonProps {
  icon: LucideIcon
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon: Icon, ...props }, ref) => {
    return (
      <Button {...props} size="icon" ref={ref}>
        <Icon className="h-4 w-4" />
      </Button>
    )
  },
)
IconButton.displayName = 'IconButton'

export { IconButton }
